var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestionMark3 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4 7.0001C13.4 10.5347 10.5346 13.4001 6.99998 13.4001C3.46535 13.4001 0.599976 10.5347 0.599976 7.0001C0.599976 3.46548 3.46535 0.600098 6.99998 0.600098C10.5346 0.600098 13.4 3.46548 13.4 7.0001ZM6.99999 4.6001C6.70488 4.6001 6.44605 4.75947 6.30652 5.00068C6.08529 5.38313 5.59591 5.51382 5.21346 5.29258C4.83101 5.07135 4.70032 4.58197 4.92155 4.19952C5.33532 3.48424 6.11064 3.0001 6.99999 3.0001C8.32547 3.0001 9.39999 4.07461 9.39999 5.4001C9.39999 6.44507 8.73214 7.33406 7.79999 7.66353V7.8001C7.79999 8.24192 7.44181 8.6001 6.99999 8.6001C6.55816 8.6001 6.19999 8.24192 6.19999 7.8001V7.0001C6.19999 6.55827 6.55816 6.2001 6.99999 6.2001C7.44181 6.2001 7.79999 5.84193 7.79999 5.4001C7.79999 4.95827 7.44181 4.6001 6.99999 4.6001ZM6.99998 11.0001C7.4418 11.0001 7.79998 10.6419 7.79998 10.2001C7.79998 9.75827 7.4418 9.4001 6.99998 9.4001C6.55815 9.4001 6.19998 9.75827 6.19998 10.2001C6.19998 10.6419 6.55815 11.0001 6.99998 11.0001Z",
    fill: "#2C2960"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionMark3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question-mark-3.0607240f.svg";
export { ForwardRef as ReactComponent };